import { BsCheck2Circle } from "react-icons/bs";
import Moment from "react-moment";
import { colors } from "../../../../utils/data";

export default function Approver({
  approver,
  last,
  auth,
  type,
  email,
  handleAccept,
  handleReject,
}: any) {
  if (auth?.accessLevel !== 5 && auth?.accessLevel !== 9) {
    if (approver?.email !== email || !approver?.email) return <></>;
  }
  return (
    <div className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3 flex justify-between items-start">
      <div className="w-12 flex flex-col justify-center items-center">
        <div
          className="flex justify-center items-center w-8 h-8 rounded-full"
          style={{
            backgroundColor: `${colors[approver?.status] || "#9ca3af"}`,
          }}
        >
          <BsCheck2Circle color="#FFFFFF" size={18} />
        </div>
        <div className="">
          <div
            className={`border-l ${last ? "border-white" : ""} ${
              approver?.remarks ? "h-28 sm:h-20" : "h-24 sm:h-16"
            }`}
          ></div>
          <div className=""></div>
        </div>
      </div>
      <div className="bg-white mb-2 flex flex-col w-full -mt-2">
        <div className="flex justify-between p-2">
          <div className="flex flex-col sm:flex-row justify-between w-full">
            <div className="font-bold">
              <div className="">{approver?.name}</div>
              <div className="text-gray-500" style={{ fontSize: 10 }}>
                Email : {approver?.email || "-"}
              </div>
            </div>

            {auth?.email === approver?.email && (
              <div className="">
                {approver?.status !== "Not Applicable" && (
                  <div className="flex">
                    <button
                      onClick={() => handleAccept({ approver, type })}
                      className="border py-1 bg-green-100 px-6 mx-1"
                    >
                      Approve
                    </button>
                    <button
                      onClick={() => handleReject({ approver, type })}
                      className="border py-1 bg-red-100 px-6"
                    >
                      Reject
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="px-2 pb-2 pt-1 flex flex-col justify-between text-xs">
          {approver?.remarks && (
            <div className="" style={{ fontSize: 12 }}>
              Remarks: {approver?.remarks}
            </div>
          )}
          <div
            className={`capitalize`}
            style={{ color: `${colors[approver?.status] || "#9ca3af"}` }}
          >
            {approver?.status !== "Pending" && approver?.status}
          </div>
          {approver?.date ? (
            <div className="flex justify-between text-gray-600 mr-1">
              <Moment format={"Do, MMM, YYYY"}>{approver?.date}</Moment>
            </div>
          ) : (
            ""
          )}
        </div>

        <div className=""></div>
      </div>
    </div>
  );
}
